import { SortType } from "../SortType";

export interface WaitlistFilters {
  page_no: number;
  limit: number;
  sort_by: string;
  sort_type: SortType;
}

export function parseQueryParamsForWaitlistFilters(
  params: WaitlistFilters | null,
  query_params: URLSearchParams,
): WaitlistFilters {
  return {
    page_no: params?.page_no ?? (Number(query_params.get("page_no")) || 1),
    limit: params?.limit ?? (Number(query_params.get("limit")) || 30),
    sort_by: params?.sort_by ?? query_params.get("sort_by") ?? "createdAt",
    sort_type:
      params?.sort_type ??
      ((query_params.get("sort_type") as SortType) || SortType.DESC),
  };
}
